import React from 'react';
import {useTranslation} from "react-i18next";

import { Button } from 'antd';
import { InstagramOutlined } from '@ant-design/icons';
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';

import {UBOT_FACEBOOK_LINK, UBOT_INSTAGRAM_LINK, UBOT_LINKEDIN_LINK} from "../../../util/constant";

import logo from '../../../assets/img/common/logo.png';

const MainFooter = () => {

    const {t} = useTranslation();

    return (
        <div className="ubot-landing-footer">
            <div className="container">
                <div className="logo-wrapper">
                    <img src={logo} alt="Ubot Logo" className="footer-logo" />
                    <p className="copy-right">{t('copyRight')}</p>
                </div>
                <div className="social-link-wrapper">
                    <a href={UBOT_LINKEDIN_LINK} target='_blank' rel='noreferrer'>
                        <Button shape="circle" className="no-border me-2 bg-transparent color-white" size="large" icon={<FaLinkedinIn />} />
                    </a>
                    <a href={UBOT_FACEBOOK_LINK} target='_blank' rel='noreferrer'>
                        <Button shape="circle" className="no-border me-2 bg-transparent color-white" size="large" icon={<FaFacebookF />} />
                    </a>
                    <a href={UBOT_INSTAGRAM_LINK} target='_blank' rel='noreferrer'>
                        <Button shape="circle" className="no-border me-2 bg-transparent color-white" size="large" icon={<InstagramOutlined />} />
                    </a>
                </div>
            </div>
        </div>
    )
};

export default MainFooter;